/**************************************************
 * Nombre:       Parrafp_fundador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Resultado from "../../../Tarjetas/Tarjeta_Resultado";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Parrafp_fundador = () => {
    const {sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: sTab ? 16 : 20, fontWeight: 400, color: '#fff'}}>
                    En un mundo lleno de “gurús” y “expertos” con logros de papel, prefiero que hablen los hechos.
                    Mi experiencia no viene de cursos ni teorías: viene de construir, dirigir y estar al frente de
                    negocios reales, donde las ideas se prueban en el mercado… o no funcionan.


                    <br/>
                    <br/>

                    No te voy a guiar por lo que dice un libro, sino por lo que realmente da resultados allá afuera.
                </Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                <Typography sx={{fontSize: sTab ? 24 : 30, fontWeight: 700, color: '#fff'}}>

                    Soy fundador de:
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={sTab ? 2 : 4}
                >


                    {empresas.map((item, index) => {
                        return (
                            <Grid container size={{xs: 12, sm: 12, md: 4}}>
                                <Tarjeta_Resultado item={item}/>
                            </Grid>
                        )
                    })}
                </Grid>
            </Grid>

        </Grid>
    )

}
export default Parrafp_fundador

const empresas = [
    {
        nombre: 'Luminica',
        descripcion: 'Estudio creativo especializado en potenciar grandes marcas.'
    },
    {
        nombre: 'Sociedad Cáfe',
        descripcion: 'El lugar donde hacemos que el café sea el pretexto perfecto para conectar ideas, personas y buenos momentos.'
    },
    {
        nombre: 'Sociedad brand',
        descripcion: 'Agencia de branding y desarrollo de marca con foco en el sector café.'
    },
]